<app-navbar-style-four></app-navbar-style-four>

<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>{{blogData.title}}</h3>

            <ul class="inner-list">
                <li><i class='bx bx-user'></i> Tom black</li>
                <li><i class='bx bx-calendar'></i> November 21, 2020</li>
                <li><i class='bx bxs-chat'></i> 3 Comments</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots-2"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="blog-details-area pb-70 ">
    <div class="container">
        <div class="row d-flex justify-content-center">
            
            <div class=" col-md-8 ">
                <div class="blog-article">
                    <div class="blog-article-img " >
                        <img style="height: 270px;width: 750px;" [src]="sanitizer.bypassSecurityTrustResourceUrl(webhost  + blogData.cover_image!)" alt="Images">
<!--                        <img style="height: 270px;width: 750px;" src="assets/img/blog/blogsample.jpeg" alt="Images">-->
                    </div>
                    <div class="row icon">
                        <div class="col-md-3">
                            <p ><i class="bx bx-time-five p-1"></i>05 Jan 2023</p>
                        </div>          
                        <div class="col-md-3">
                            <p ><i class="bx bx-purchase-tag-alt p-1"></i>0 Comments</p> 
                        </div>
                    </div>
                    <div class="another-content">
                        <h2 >{{blogData.title}}</h2>
                        <p [innerHTML]="blogData.long_desc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui offi.</p>
                        <p>cia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem tem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est.</p>
                    </div>
                </div>
            </div>  

        </div>
    </div>
</div>

<!-- //Previous blog details hided below// -->
<!-- <div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>15 SEO Best Practices: Website Traffic</h3>

            <ul class="inner-list">
                <li><i class='bx bx-user'></i> Tom black</li>
                <li><i class='bx bx-calendar'></i> November 21, 2020</li>
                <li><i class='bx bxs-chat'></i> 3 Comments</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots-2"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div> -->

<!-- <div class="blog-details-area pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-article">
                    <div class="blog-article-img">
                        <img src="assets/img/blog/blog-details.jpg" alt="Images">
                    </div>

                    <div class="article-content">
                        <h2>SEO Best Practice for Web Traffic</h2>
                        <div class="content-text">
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incidunt ut labore et dolore plicabo. Nemo enim ipsam voluptatem quia voluptas sit aspertur aut odit aut quia consequuntur magni.</p>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore plicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                        <blockquote class="blockquote"> 
                            <p>I see SEO becoming a normalized marketing tactic, the same way TV, radio, and print are traditionally.</p>
                            <span>HERBERT BAYARD SWOPE</span>
                        </blockquote>
                    </div>

                    <div class="another-content">
                        <h2>SEO is Cost-Effective Strategy</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui offi.</p>
                        <p>cia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem tem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est.</p>
                        <div class="content-img">
                            <div class="row">
                                <div class="col-6 col-md-6">
                                    <img src="assets/img/blog/blog-details2.jpg" alt="Images">
                                </div>

                                <div class="col-6 col-md-6">
                                    <img src="assets/img/blog/blog-details3.jpg" alt="Images">
                                </div>
                            </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore plicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                    </div>

                    <div class="blog-article-share">
                        <div class="row align-items-center">
                            <div class="col-lg-7 col-sm-6 col-md-7">
                                <div class="blog-tag">
                                    <ul>
                                        <li>Tags:</li>
                                        <li><a routerLink="/blog">#SEO</a></li>
                                        <li><a routerLink="/blog">#Business</a></li>
                                        <li><a routerLink="/blog">#Internet</a></li>
                                        <li><a routerLink="/blog">#Property</a></li>
                                    </ul>
                                </div>
                            </div>
                            
                            <div class="col-lg-5 col-sm-6 col-md-5">
                                <ul class="social-icon">
                                    <li><a target="_blank" href="#"><i class="bx bxl-facebook"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-twitter"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-instagram"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-linkedin"></i></a></li>
                                    <li><a target="_blank" href="#"><i class="bx bxl-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="article-author">
                        <ul>
                            <li>
                                <img src="assets/img/blog/blog-profile1.png" alt="Image">
                                <h3>Devit Killer</h3>
                                <span>Author, Writer</span>
                                <p>I’m devit  hack from an initial feasibility study, continuing through sucessl implna business you have to be But we know there</p>
                            </li>
                        </ul>
                        <div class="author-social-link">
                            <ul class="social-icon">
                                <li><a target="_blank" href="#"><i class="bx bxl-facebook"></i></a></li>
                                <li><a target="_blank" href="#"><i class="bx bxl-twitter"></i></a></li>
                                <li><a target="_blank" href="#"><i class="bx bxl-instagram"></i></a></li>
                                <li><a target="_blank" href="#"><i class="bx bxl-linkedin"></i></a></li>
                                <li><a target="_blank" href="#"><i class="bx bxl-youtube"></i></a></li>
                            </ul>
                        </div>
                        <div class="author-shape">
                            <div class="shape1"><img src="assets/img/blog/blog-shape.png" alt="Images"></div>
                            <div class="shape2"><img src="assets/img/blog/blog-shape2.png" alt="Images"></div>
                            <div class="shape-dots"><img src="assets/img/blog/blog-dots.png" alt="Images"></div>
                        </div>
                    </div>

                    <div class="article-post">
                        <div class="row">
                            <div class="col-lg-6 col-sm-6">
                                <div class="article-post-share">
                                    <span>Jun 12, 2020 / <a routerLink="/blog">SEO</a></span>
                                    <a routerLink="/blog-details"><h3>Successful digital marketer does first to ensure they get</h3></a>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-6">
                                <div class="article-post-share">
                                    <span>April 19, 2020 / <a routerLink="/blog">Web</a></span>
                                    <a routerLink="/blo-detailsg"><h3 class="active">Marketer who knows how to execute their campaigns</h3></a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="comments-wrap">
                        <h3 class="title">Comments (02)</h3>

                        <ul>
                            <li>
                                <img src="assets/img/blog/blog-profile1.png" alt="Image">
                                <h3>Devit Killer</h3>
                                <span>Jnauary 12, 2020</span>
                                <p>Software hack from an initial feasibility study, continuing through l implna business you have to be But we know there's a better</p>
                                <a routerLink="/blog-details"> Reply</a>
                            </li>
                            <li class="ml-30">
                                <img src="assets/img/blog/blog-profile2.png" alt="Image">
                                <h3>Morah Jein </h3>
                                <span>July 12, 2020</span>
                                <p>Software hack from an initial feasibility study, continuing through l implna business you have to be But we know there's a better</p>
                                <a routerLink="/blog-details"> Reply</a>
                            </li>
                        </ul>
                    </div>

                    <div class="comments-form">
                        <div class="contact-form">
                            <h3>Leave a Comment</h3>

                            <form id="contactForm">
                                <div class="row">
                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-user'></i>
                                            <input type="text" name="name" class="form-control" required data-error="Please enter name" placeholder="Name*">
                                        </div>
                                    </div>
        
                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-user'></i>
                                            <input type="email" name="name" class="form-control" required data-error="Please enter email" placeholder="Email*">
                                        </div>
                                    </div>
        
                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-phone' ></i>
                                            <input type="text" name="phone"  class="form-control" required data-error="Please enter your phone number" placeholder="Phone">
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-sm-6">
                                        <div class="form-group">
                                            <i class='bx bx-copy-alt'></i>
                                            <input type="text" name="website"  class="form-control" required data-error="Please enter your website" placeholder="Website">
                                        </div>
                                    </div>
        
                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <i class='bx bx-envelope'></i>
                                            <textarea name="message" class="form-control" id="message" cols="30" rows="8" required data-error="Write your message" placeholder="Your Message"></textarea>
                                        </div>
                                    </div>
        
                                    <div class="col-lg-12 col-md-12">
                                        <button type="submit" class="default-btn">Post A Comment <i class='bx bx-plus'></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="blog-widget-left">
                    <div class="blog-widget ">
                        <h3 class="title">Search</h3>

                        <div class="search-widget">
                            <form class="search-form">
                                <input type="search" class="form-control" placeholder="Search...">
                                <button type="submit"><i class="bx bx-search"></i></button>
                            </form>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Recent Posts</h3>

                        <div class="widget-popular-post">
                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg1" role="img"></span></a>
                                <div class="info">
                                    <span>Jnauary 12, 2020</span> 
                                    <h4 class="title-text"><a routerLink="/blog-details">A Guide to Google SEO</a></h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>

                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg2" role="img"></span></a>
                                <div class="info">
                                    <span>June 30, 2020</span>
                                    <h4 class="title-text"><a routerLink="/blog-details">15 SEO Best Practices</a></h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>

                            <article class="item">
                                <a routerLink="/blog-details" class="thumb"><span class="full-image cover bg3" role="img"></span></a>
                                <div class="info">
                                    <span>April 09, 2020</span>
                                    <h4 class="title-text"><a routerLink="/blog-details">Website Architecture</a> </h4>
                                    <p>Jhon hack from an iitial feaity study</p>
                                </div>
                            </article>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Categories</h3>

                        <div class="widget_categories">
                            <ul>
                                <li><a routerLink="/blog">Design <span>(1)</span></a></li>
                                <li><a routerLink="/blog">Lifestyle <span>(4)</span></a></li>
                                <li><a routerLink="/blog">Camping <span>(3)</span></a></li>
                                <li><a routerLink="/blog">Support <span>(2)</span></a></li>
                                <li><a routerLink="/blog">Device <span>(6)</span></a></li>
                                <li><a routerLink="/blog">Internet <span>(18)</span></a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="blog-widget">
                        <h3 class="title">Tags</h3>

                        <ul class="blog-widget-tag">
                            <li><a routerLink="/blog">#SEO</a></li>
                            <li><a routerLink="/blog">#Internet</a></li>
                            <li><a routerLink="/blog">#Web</a></li>
                            <li><a routerLink="/blog">#Sass</a></li>
                            <li><a routerLink="/blog">#It & Support</a></li>
                            <li><a routerLink="/blog">#Tik</a></li>
                            <li><a routerLink="/blog">#Tips</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- <div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer-style-two></app-footer-style-two>
